import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/UserAuth';

function Navbar() {
  const navigate = useNavigate();
  const { user, logOut } = useAuth();

  const handleLogOut = (e) => {
    e.preventDefault();
    logOut();
    navigate('/login');
  };

  ///////////////////////////////////////////////////////////////////////////////////////
  return (
    <div>
      <header className='p-3 bg-dark text-white'>
        <div className='container'>
          <div className='d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start'>
            <NavLink to='/' className='d-flex align-items-center mb-2 mb-lg-0 text-white text-decoration-none me-5'>
              <strong>Firebase-CRUD</strong>
            </NavLink>

            <ul className='nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0 nav-pills'>
              <li>
                <NavLink to='/' className='nav-link px-2 text-white'>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to='/upload' className='nav-link px-2 text-white'>
                  Uploder
                </NavLink>
              </li>
              <li>
                <NavLink to='/about' className='nav-link px-2 text-white'>
                  About
                </NavLink>
              </li>
            </ul>

            <div className='text-end my-3'>
              {!user && (
                <>
                  <button type='button' className='btn btn-outline-light me-2' onClick={() => navigate('/login')}>
                    Login
                  </button>
                  <button type='button' className='btn btn-warning' onClick={() => navigate('/signup')}>
                    Sign-up
                  </button>
                </>
              )}
              {user && (
                <button type='button' className='btn btn-warning' onClick={handleLogOut}>
                  Logout
                </button>
              )}
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Navbar;
